import axios from "axios";

const mock = {
  getFullToken: () => "",
  getToken: () => "",
};

const httpInstance = axios.create({});

httpInstance.interceptors.request.use(function (config) {
  const identity = window.identityService || mock;
  if (typeof config.headers["Authorization"] === "undefined") {
    if (config.url.substring(0, 5) === "/api/") {
      config.headers["Authorization"] = `${
        identity.getFullToken().token_type
      } ${identity.getToken()}`;
    }
  }

  return config;
});

export const http = httpInstance;
